// extracted by mini-css-extract-plugin
export default {"smallBlue":"PageBlock_smallBlue__L4AV4","shadow":"PageBlock_shadow__lVUal"};